import { render, staticRenderFns } from "./WfUserDevCollectionList.vue?vue&type=template&id=d54bcebc&scoped=true&"
import script from "./WfUserDevCollectionList.vue?vue&type=script&lang=js&"
export * from "./WfUserDevCollectionList.vue?vue&type=script&lang=js&"
import style0 from "./WfUserDevCollectionList.vue?vue&type=style&index=0&id=d54bcebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54bcebc",
  null
  
)

export default component.exports